<template>
    <v-container class="pa-0 ma-0" fluid style="background-color: #FFF6E5; height:100% ">
        <v-toolbar dense :color="'#FF9C00'" style="min-height: 80px;">
            <v-spacer></v-spacer>
            <v-toolbar-title class="mt-6 text-center">
                <img src="../assets/logo2.png" alt="Logo" style="height: 60px;">
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>

        <v-row v-if="reserva && !consultaEnviada" class="mx-4 mt-6">
            <v-col class="text-center">
                <span style="font-size: 1.4rem;" class="mx-16">
                    {{ $t('mensajes.texto_consulta_agencia') }}
                </span>
            </v-col>
        </v-row>

        <v-row v-if="reserva && !consultaEnviada" dense class="mx-4 mt-6" justify="center">
            <v-col cols="8" md="4">
                <v-textarea style="background-color: white;" v-model="consulta" outlined label="" dense
                    autocomplete="off" hide-details rows="10"></v-textarea>
            </v-col>
        </v-row>

        <v-row v-if="reserva && !consultaEnviada" class="mt-6 mb-6" justify="center">
            <v-chip link @click="_enviarConsulta()" large class="ma-2 px-8 mr-8 hover-color" :color="miColorAzul"
                :text-color="miColorNaranja" style="font-size: 1.2rem;">
                {{ $t('mensajes.enviar_consulta') }}
                <v-icon class="ml-6" size="2rem" right>mdi-arrow-right</v-icon>
            </v-chip>
        </v-row>

        <v-row v-if="reserva && consultaEnviada" class="mx-4 mt-6">
            <v-col class="text-center">
                <span style="font-size: 1.4rem;" class="mx-16">
                    {{ $t('mensajes.consulta_enviada') }}
                </span>
            </v-col>
        </v-row>

        <v-row v-if="reserva && consultaEnviada" class="mt-6 mb-6" justify="center">
            <v-chip link @click="_irAWebAlCamino()" large class="ma-2 px-8 mr-8 hover-color"
                :color="miColorAzul" :text-color="miColorNaranja" style="font-size: 1.2rem;">
                {{ $t('mensajes.ir_al_camino') }}
                <v-icon size="2rem" right>mdi-arrow-right</v-icon>
            </v-chip>
        </v-row>



    </v-container>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
    data() {
        return {
            consulta: '',

            enviandoConsulta: false,
            consultaEnviada: false,



            miColorNaranja: '#FF9C00',
            miColorAzul: '#191970',

            reserva: null,
        };
    },
    computed: {


    },
    mounted() {
        this.language = this.$route.params.language.toLowerCase();
        this.$i18n.locale = this.language.toLowerCase();
        this.enviandoConsulta = false;
        this.consultaEnviada = false;

        const hash = this.$route.params.hash;
        this._getReservaByHash(hash);

    },
    methods: {
        ...mapActions("reservas", ["getReservaByHash", "enviarConsulta"]),


        async _getReservaByHash(hash) {
            this.reserva = await this.getReservaByHash([hash]);
          
        },

        async _enviarConsulta() {
            if (this.reserva && this.consulta && !this.enviandoConsulta) {
                this.enviandoConsulta = true;
                var res = await this.enviarConsulta([this.reserva.id, this.consulta]);
                if (res) {
                    this.consultaEnviada = true;
                
                }
                this.enviandoConsulta = false;

            }
        },

        _irAWebAlCamino() {
            if (this.reserva && this.reserva.camino) {
                if (this.language == 'en') {
                    window.open(this.reserva.camino.link_web, '_blank');
                } else if (this.language == 'de') {
                window.open(this.reserva.camino.link_web, '_blank');
            } else {
                    window.open(this.reserva.camino.link_web, '_blank');
                }
            }
        },




    },
};
</script>

<style scoped></style>
